import React from "react";
import LegalPage from "./LegalPage";
import { deliveryContent } from "./legalContent";

/**
 * /delivery — how and when what you paid for reaches you.
 *
 * Its own page rather than a paragraph in the Terms because the payment
 * processor's point-of-sale review looks for a link with this name, and because
 * "delivery" for software surprises people: they expect a waiting period and
 * there isn't one.
 *
 * No version number: unlike the Terms, nobody accepts this at signup, so there
 * is nothing to pin an account against.
 */
const Delivery = () => <LegalPage content={deliveryContent} />;

export default Delivery;
